import NiotaClassicApiService from '@/services/niotaClassicApiService';
import { mapState } from 'vuex';
import formMixin from '../formMixin';
import cloneDeep from 'lodash/cloneDeep';
import isObject from 'lodash/isObject';
import isArray from 'lodash/isArray';
import get from 'lodash/get';
import set from 'lodash/set';
const techSpecKeys = ['Model', 'Usage', 'Configuration', 'Connectivity', 'Frequency', 'TX Power', 'TX Distance', 'Power Supply', 'Operating Temperature', 'Security', 'Mounting', 'Dimensions', 'Weight', 'Standard', 'Battery', 'Battery Life', 'Firmware', 'Precision', 'Installation Height', 'Other'];
export default {
  name: 'NiotaClassicDevicetypesCreateEditDialog',
  mixins: [formMixin],
  props: {
    isOpen: {
      type: Boolean,
      default: false
    },
    isEditForm: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      techSpecKeys: techSpecKeys,
      accounts: [],
      deviceTypes: [],
      niotaImportClipboard: null
    };
  },
  computed: {
    ...mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color', 'UiTheme', 'permissions']),
    isSuperSystemAdmin() {
      return this.permissions['super.system.manage'];
    },
    showImportClipboard() {
      return !this.isEditForm && this.isSuperSystemAdmin;
    },
    visibilityItems() {
      return [{
        text: this.$i18n_t('NiotaClassic.DeviceTypes.visibility.account'),
        value: 'account'
      }, {
        text: this.$i18n_t('NiotaClassic.DeviceTypes.visibility.everyone'),
        value: 'everyone'
      }];
    },
    cardButtons() {
      return [{
        icon: 'fas fa-save',
        title: this.formItem.id ? this.$i18n_t('Common.save') : this.$i18n_t('Common.saveAndCreate'),
        type: 'submit'
      }, {
        icon: 'fal fa-times',
        color: 'danger',
        action: 'close',
        tooltip: this.$i18n_t('Common.cancel')
      }];
    },
    formValue() {
      return this.$refs.form ? this.$refs.form.value : false;
    }
  },
  watch: {
    isOpen(state) {
      if (state) {
        this.initializeForm();
      }
    }
  },
  created() {
    this.initializeForm();
  },
  methods: {
    get: get,
    initializeForm() {
      this.formItem = cloneDeep(this.editedItem || {});
      this.prepareFormItem();
      NiotaClassicApiService.accountsFetchPlain().then(res => {
        this.accounts = res.data.accounts;
      }).catch(() => {
        this.$snack(this.$i18n_t('NiotaClassic.DeviceTypes.snacks.fetchAccountFailed'), 'error');
      });
      NiotaClassicApiService.deviceTypesGetPlain().then(res => {
        this.deviceTypes = res.data.devicetypes;
      }).catch(() => {
        this.$snack(this.$i18n_t('NiotaClassic.DeviceTypes.snacks.fetchFailed'), 'error');
      });
    },
    attachmentsUpdated(data) {
      this.formItem.properties.manufacturer.device_manual_file = data;
    },
    // FIXME: get deviceTypeVariables, parserVariables, variableTypeFinder methods from niota-classic/devices/detailsMixin.js
    deviceTypeVariables(deviceType) {
      var variableKeys = [];
      const type = deviceType.parser.type;
      //parser type single
      if (type === 'single' || type === 'function') {
        variableKeys = this.parserVariables(deviceType.parser.config.variables || {});
      }
      //parser type multi
      if (type === 'multi') {
        let parsers = Object.keys(deviceType.parser.config || {});
        parsers.forEach(parser_n => {
          let indivParserVariables = parser_n !== '__switch' ? deviceType.parser.config[parser_n].variables || [] : [];
          Object.keys(indivParserVariables).forEach(variable => {
            variableKeys.push({
              variable: indivParserVariables[variable]['name'] ? indivParserVariables[variable]['name'] : '',
              parser: parser_n,
              value_type_name: this.variableTypeFinder(indivParserVariables[variable])
            });
          });
        });
      }
      return variableKeys;
    },
    parserVariables(deviceTypeVariables) {
      let variables = [];
      Object.keys(deviceTypeVariables).forEach(key => {
        variables.push({
          variable: deviceTypeVariables[key]['name'] ? deviceTypeVariables[key]['name'] : '',
          value_type_name: this.variableTypeFinder(deviceTypeVariables[key])
        });
      });
      return variables;
    },
    variableTypeFinder(variable) {
      let variableType = '';
      if (variable) {
        if (variable['suffix']) {
          variableType = variable['suffix'];
          if (variable['value_type'] && variable['value_type'].name) {
            variableType = variable['value_type'].name;
          }
        }
        // for boolean case
        if (variable['value_type']) {
          if (variable['value_type'] && variable['value_type'].name) {
            variableType = variable['value_type'].name;
          }
        }
      }
      return variableType;
    },
    prepareFormItem() {
      if (!this.formItem.properties) {
        this.formItem.properties = {};
        this.formItem.properties.certified = false;
        this.formItem.properties.certifiedBy = this.isSuperSystemAdmin ? 'DIGIMONDO' : null;
      }
      if (!this.formItem.properties.manufacturer) {
        this.formItem.properties.manufacturer = {};
      }
      if (!isArray(this.formItem.properties.manufacturer.device_manual_file)) {
        if (this.formItem.properties.manufacturer.device_manual_file && this.formItem.properties.manufacturer.device_manual_file.constructor === Object) {
          this.formItem.properties.manufacturer.device_manual_file = [this.formItem.properties.manufacturer.device_manual_file];
        }
      }
      if (!this.formItem.properties.technical_specs) {
        this.formItem.properties.technical_specs = {};
      }
    },
    handleImport(deviceTypeObject) {
      if (isObject(deviceTypeObject)) {
        delete deviceTypeObject.id;
        delete deviceTypeObject.accountId;
        delete deviceTypeObject.account;
        deviceTypeObject.properties.certified = false;
        this.formItem = cloneDeep(deviceTypeObject);
        this.prepareFormItem();
      }
    },
    handleImportClipboard() {
      NiotaClassicApiService.deviceTypesValidateCopy(this.niotaImportClipboard).then(res => {
        this.formItem = res.data.devicetype;
        if (!this.isSuperSystemAdmin) {
          this.formItem.certified = false;
          this.formItem.properties.certifiedBy = null;
        }
        this.copySourceInfo = res.data.devicetype.properties.sourceInfo;
        this.formItem.copy = res.data.devicetype.title;
        this.$refs.form.validate();
      }).catch(() => {
        this.$snack(this.$i18n_t('NiotaClassic.DeviceTypes.snacks.validateClipboardFailed'), 'error');
      });
    },
    createOrUpdateDeviceType() {
      if (this.formItem.id) {
        this.updateRequest();
      } else {
        this.createRequest();
      }
    },
    updateRequest() {
      NiotaClassicApiService.deviceTypesUpdate(this.formItem.id, this.formItem).then(() => {
        this.$emit('update', this.formItem);
        this.$emit('close');
        this.$snack(this.$i18n_t('NiotaClassic.DeviceTypes.snacks.updateSuccess'), 'success');
      }).catch(() => {
        this.$snack(this.$i18n_t('NiotaClassic.DeviceTypes.snacks.updateFailed'), 'error');
      });
    },
    createRequest() {
      NiotaClassicApiService.deviceTypesCreate(this.formItem).then(() => {
        this.$emit('created');
        this.$emit('close');
        this.$snack(this.$i18n_t('NiotaClassic.DeviceTypes.snacks.createSuccess'), 'success');
      }).catch(() => {
        this.$snack(this.$i18n_t('NiotaClassic.DeviceTypes.snacks.createFailed'), 'error');
      });
    },
    accountUpdated() {
      if (this.formItem.account) {
        this.formItem.accountId = this.formItem.account.id;
      }
    },
    uploadImage(image) {
      NiotaClassicApiService.uploadImage(image, 'devicetype').then(data => {
        this.formItem.image = data.files[0];
        this.formItem = cloneDeep(this.formItem);
      }).catch(() => {
        this.$snack(this.$i18n_t('NiotaClassic.DeviceTypes.snacks.imageUploadFailed'), 'error');
      });
    },
    updateModel() {
      this.formItem = cloneDeep(this.formItem);
    },
    selectedBattery(item) {
      if (!item) {
        return;
      }
      if (item.value_type_name === 'Boolean' || get(this.formItem, 'properties.battery_type') === 'Boolean') {
        set(this.formItem, 'properties.battery_warning_level', '');
        set(this.formItem, 'properties.battery_alert_level', '');
      }
      set(this.formItem, 'properties.battery_level', item.variable);
      set(this.formItem, 'properties.battery_type', item.value_type_name);
    }
  }
};